'use strict';

var _ = require('lodash');
var FlightAnalysisService = function FlightAnalysisService(gridSettingsService, gridSettingsMergeService, dataRetrieverService, constants) {
  function isAnyActiveSort(sortCriteria) {
    var columnsWithActiveSort = _.filter(sortCriteria.columns, function (column) {
      return !column.isNotSorted();
    });
    return columnsWithActiveSort.length > 0;
  }

  /**
   * Set sorting for data retrievers.
   * First - When user switch from non-post-departure to post-departure app will build grids only on retrieving data. It means we need to set Sort criteria manually.
   * Second - on showing flight screen app doesn't build class and service grid, so for this data retrievers we should set sorting.
   * If set empty sort criteria - it will work, but app will make 2 requests for the same data: first without sort criteria (by charts), second - with sort criteria (by grid)
   *
   * This function will set sort criteria similar to grid.
   */
  function setSorting(gridId, screen, mode) {
    var defaultGridSettings = gridSettingsService.getDefaultGridSettings(gridId);
    gridSettingsService.retrieveGridSettings(gridId).then(function (userGridSettings) {
      if (isAnyActiveSort(userGridSettings.sortCriteria)) {
        return userGridSettings.sortCriteria;
      } else {
        return defaultGridSettings.defaultSortCriteria;
      }
    }, function () {
      return defaultGridSettings.defaultSortCriteria;
    }).then(function (sortCriteria) {
      dataRetrieverService.gridSortApplied(sortCriteria, screen, mode);
    });
  }
  function setDataRetrieversSorting() {
    setSorting('cabin-flight-analysis-post-departure', constants.FLIGHT_SCREEN, constants.CABIN_POST_DEPARTURE_MODE);
    setSorting('class-flight-analysis-post-departure', constants.FLIGHT_SCREEN, constants.CLASS_POST_DEPARTURE_MODE);
    setSorting('class-flight-analysis', constants.FLIGHT_SCREEN, constants.FLIGHT_CLASS_PROFILE_MODE);
    setSorting('class-flight-analysis', constants.FLIGHT_SCREEN, constants.CLASS_MODE);
    setSorting('service-flight-analysis', constants.FLIGHT_SCREEN, constants.SERVICE_MODE);
  }
  return {
    setDataRetrieversSorting: setDataRetrieversSorting
  };
};
FlightAnalysisService.$inject = ['GridSettingsService', 'GridSettingsMergeService', 'DataRetrieverService', 'DataRetrieverConstantsService'];
module.exports = FlightAnalysisService;